export const py = {
  dc_motor: `
import machine
import time
import system_state

version = 1.1

dc_ina = machine.Pin(7, machine.Pin.OUT)
dc_inb = machine.Pin(11, machine.Pin.OUT)
pwm1 = machine.PWM(dc_ina)
pwm2 = machine.PWM(dc_inb)

def _map(value, fromlow, fromhigh, tolow, tohigh):
  return int((value - fromlow) * (tohigh - tolow) / (fromhigh - fromlow) + tolow)

def get_version():
  return version

# def init():
#     pass

def init():
  global pwm1, pwm2
  pwm1.deinit()
  pwm2.deinit()
  pwm1 = machine.PWM(dc_ina)
  pwm2 = machine.PWM(dc_inb)
  pwm1.freq(20000)
  pwm2.freq(20000)
  pwm1.duty(_map(100,0,100,0,1023))
  pwm2.duty(_map(100,0,100,0,1023))

def run(speed):
  global pwm1, pwm2
  if(system_state.get_extention_flag(3) == False):
      init()
      system_state.set_extention_flag(3,True)

  if speed < -100:
      speed = -100
  elif speed > 100:
      speed = 100
  if speed > 0:
      pwm1.duty(_map(speed,0,100,0,1023))
      pwm2.duty(_map(0,0,100,0,1023))
  elif speed < 0:
      pwm1.duty(_map(0,0,100,0,1023))
      pwm2.duty(_map(-speed,0,100,0,1023))
  else:
      pwm1.duty(0)
      pwm2.duty(0)
      # pwm1.duty(_map(100,0,100,0,1023))
      # pwm2.duty(_map(100,0,100,0,1023))
  `,
  lego_motor: `
import machine
import time
import system_state
version = 1.1

dc_ina = machine.Pin(7, machine.Pin.OUT)
dc_inb = machine.Pin(11, machine.Pin.OUT)
pwm1 = machine.PWM(dc_ina)
pwm2 = machine.PWM(dc_inb)

def _map(value, fromlow, fromhigh, tolow, tohigh):
  return int((value - fromlow) * (tohigh - tolow) / (fromhigh - fromlow) + tolow)

def get_version():
  return version
def init():
  pass
def init_test():
  global pwm1, pwm2
  pwm1.deinit()
  pwm2.deinit()
  pwm1 = machine.PWM(dc_ina)
  pwm2 = machine.PWM(dc_inb)
  pwm1.freq(20000)
  pwm2.freq(20000)
  pwm1.duty(_map(100,0,100,0,1023))
  pwm2.duty(_map(100,0,100,0,1023))

def run(speed):
  global pwm1, pwm2
  if(system_state.get_extention_flag(2) == False):
      init_test()
      system_state.set_extention_flag(2,True)
  if speed < -100:
      speed = -100
  elif speed > 100:
      speed = 100
  if speed > 0:
      pwm1.duty(_map(speed,0,100,0,1023))
      pwm2.duty(_map(0,0,100,0,1023))
  elif speed < 0:
      pwm1.duty(_map(0,0,100,0,1023))
      pwm2.duty(_map(-speed,0,100,0,1023))
  else:
      pwm1.duty(0)
      pwm2.duty(0)
  `,
  servo: `
import machine
import time
import system_state

version = 1.2

servo1 = machine.Pin(7, machine.Pin.OUT)
servo2 = machine.Pin(11, machine.Pin.OUT)
pwm1 = machine.PWM(servo1)
pwm2 = machine.PWM(servo2)
angle1 = 90
angle2 = 90

servo_init_flag_1 = False
servo_init_flag_2 = False

def get_version():
  return version

def _map_pwm(value, fromlow, fromhigh, tolow, tohigh):
  pwm_value = int((value - fromlow) * (tohigh - tolow) / (fromhigh - fromlow) + tolow)
  if pwm_value < tolow:
      pwm_value = tolow
  if pwm_value > tohigh:
      pwm_value = tohigh
  return pwm_value

# def init():
#     pass

def init(servo_num):
  global pwm1, pwm2, angle1, angle2, servo_init_flag_1, servo_init_flag_2
  if servo_num == 1 or servo_num == "1":
      pwm1.deinit()
      pwm1 = machine.PWM(servo1)
      pwm1.freq(50)
      pwm1.duty(_map_pwm(angle1,0,180,25,128))
      servo_init_flag_1 = True
  elif servo_num == 2 or servo_num == "2":
      pwm2.deinit()
      pwm2 = machine.PWM(servo2)
      pwm2.freq(50)
      pwm2.duty(_map_pwm(angle2,0,180,25,128))
      servo_init_flag_2 = True

def run(servo_num, angle):
  global servo_init_flag_1, servo_init_flag_2
  if(system_state.get_extention_flag(1) == False):
      servo_init_flag_1 = False
      servo_init_flag_2 = False
      init(servo_num)
      system_state.set_extention_flag(1,True)
  elif(servo_num == 1 and servo_init_flag_1 == False):
      init(1)
  elif(servo_num == 2 and servo_init_flag_2 == False):
      init(2)

  global pwm1, pwm2, angle1, angle2
  if servo_num == 1 or servo_num == "1":
      angle1 = angle
      pwm1.duty(_map_pwm(angle1,0,180,25,128))
  elif servo_num == 2 or servo_num == "2":
      angle2 = angle
      pwm2.duty(_map_pwm(angle2,0,180,25,128))`,
  wls: `
from machine import ADC, Pin

version = 1.0

adc1=ADC(Pin(7,Pin.IN))
adc1.atten(ADC.ATTN_11DB)

def _map(val, min_in, max_in, min_out, max_out):
  if val >= max_in:
      return max_out
  if val <= min_in:
      return min_out
  delta_in = max_in - min_in
  delta_out = max_out - min_out
  return int( ((val - min_in)*delta_out) / delta_in + min_out)

def get_version():
  return version

def get_water_level():
  global adc1
  val = adc1.read_uv()/1000
  return _map(int(val), 0, 1720, 0, 100)`,
  micro_switch: `
from machine import ADC, Pin

version = 0.5

adc1=ADC(Pin(7,Pin.IN))
adc1.atten(ADC.ATTN_11DB)

def get_version():
  return version

def is_pressed():
  global adc1
  val = adc1.read()
  if val > 3000:
      return True
  else:
      return False
  `,
  rotary_angle_sensor: `
from machine import ADC, Pin

version = 0.5

adc1=ADC(Pin(7,Pin.IN))
adc1.atten(ADC.ATTN_11DB)

def _map(val, min_in, max_in, min_out, max_out):
  if val >= max_in:
      return max_out
  if val <= min_in:
      return min_out
  delta_in = max_in - min_in
  delta_out = max_out - min_out
  return int( ((val - min_in)*delta_out) / delta_in + min_out)

def get_version():
  return version

def get_value():
  global adc1
  val = adc1.read()
  return _map(int(val), 0, 4095, 0, 100)
  `,
  temperature_humidity_sensor: `
import sensor, time
from machine import Pin
import system_state
import math
# DHT11_CRC_ERROR = -2,
# DHT11_TIMEOUT_ERROR = -1

version = 1.0
# dht_sensor = dht.DHT11(Pin(7, Pin.OPEN_DRAIN))

last_temperature = 25
last_humidity = 55
pin_num = 7
def set_pin(pin):
  global init_flag, pin_num
  pin_num = pin
  init_flag = False

def get_version():
  return version

def get_temperature_backup(type = 'Celsius'):
  global last_temperature, pin_num
  val = sensor.get_dht11_temperature(pin_num)
  last_time = time.ticks_ms()
  while val < 0:
      if time.ticks_ms() - last_time > 5000:
          return last_temperature
      val = sensor.get_dht11_temperature(pin_num)
      time.sleep(0.2)
  last_temperature = val
  if type == 'Fahrenheit':
      val = round(32 + val*1.8)
  return val

def get_temperature(type = 'Celsius'):
  global last_temperature, pin_num
  val = sensor.get_dht11_temperature(pin_num)
  status = sensor.get_dht11_status(pin_num)
  last_time = time.ticks_ms()
  while status < 0:
      if time.ticks_ms() - last_time > 5000:
          break
      val = sensor.get_dht11_temperature(pin_num)
      status = sensor.get_dht11_status(pin_num)
      time.sleep(0.1)
  if val > 50:
      status = -4

  if status < 0:
      val = last_temperature
  else:
      last_temperature = val

  if type == 'Fahrenheit':
      val = round(32 + val*1.8)
  time.sleep(0.2)
  return val

def get_humidity():
  global last_humidity, pin_num
  val = sensor.get_dht11_humidity(pin_num)
  status = sensor.get_dht11_status(pin_num)
  last_time = time.ticks_ms()
  while status < 0:
      if time.ticks_ms() - last_time > 5000:
          break
      val = sensor.get_dht11_humidity(pin_num)
      status = sensor.get_dht11_status(pin_num)
      time.sleep(0.1)
  if val > 96:
      status = -3

  if status < 0:
      val = last_humidity
  else:
      last_humidity = val
  time.sleep(0.2)
  return val

def get_status():
  global pin_num
  status = sensor.get_dht11_status(pin_num)
  return status
  `,
  joystick: `
from machine import ADC, Pin
import time

version = 0.5

adc1=ADC(Pin(7,Pin.IN))
adc1.atten(ADC.ATTN_11DB)

adc2=ADC(Pin(11,Pin.IN))
adc2.atten(ADC.ATTN_11DB)

def _map(val, min_in, max_in, min_out, max_out):
  if val >= max_in:
      return max_out
  if val <= min_in:
      return min_out
  delta_in = max_in - min_in
  delta_out = max_out - min_out
  return int( ((val - min_in)*delta_out) / delta_in + min_out)

def get_version():
  return version

def get_x():
  global adc1
  val = adc1.read()
  return _map(int(val), 0, 4095, 0, 100)

def get_y():
  global adc2
  val = adc2.read()
  return _map(int(val), 0, 4095, 0, 100)
  `,
  led_strip: `
#!/usr/bin/env python3
# -*- coding: utf-8 -*-

import matatalab
import math, time, random
import machine, neopixel, _thread

version = 0.7

NUM_LEDS = 15
pin_num = 7
init_flag = 0

_leds = None
# _leds = neopixel.NeoPixel(machine.Pin(7), NUM_LEDS)

THREAD_SIZE = 4 * 1024

thread_flag = 0
effect_type = 0
effect_time = 0
led_count = 0
thread_stop = 0

led_color = {
1:[0,0,255],
2:[0,255,0],
3:[255,0,0],
4:[255,255,0],
5:[255,0,255],
6:[0,255,255],
7:[202,235,216],
8:[255,127,80],
9:[0,191,255],
10:[0,255,127],
}

led_index = 1

def int_led():
  global init_flag, _leds, pin_num
  if init_flag == False:
      _leds = neopixel.NeoPixel(machine.Pin(pin_num), NUM_LEDS)
      init_flag = True
  return _leds

def get_version():
  return version

def set_pin(pin):
  global init_flag, pin_num
  pin_num = pin
  init_flag = False
  print("set pin")

def show_all(r, g, b):
  # global _leds
  int_led()
  v = (r, g, b)
  _leds.fill(v)
  _leds.write()

def show_side(mode, r, g, b):
  int_led()
  if mode == 0:
      _leds[0] = (r,g,b)
      _leds[1] = (r,g,b)
      _leds[2] = (r,g,b)
  elif mode == 1:
      _leds[3] = (r,g,b)
      _leds[4] = (r,g,b)
      _leds[5] = (r,g,b)
  _leds.write()

def display(data):
  int_led()
  if(type(data) == str):
      print("not support now!")
      return
  data_len = len(data)
  for i in range(data_len / 3):
      _leds[i] = (data[3 * i], data[3 * i + 1], data[3 * i + 2])
  _leds.write()

def show_single(id, r, g, b):
  int_led()
  if(id < 0) or (id > 6):
      pass
  if(id == 0):
      show_all(r,g,b)
  else:
      _leds[id - 1] = (r,g,b)
      _leds.write()

def led_twinkle():
  int_led()
  global led_count
  led_count = 5
  for i in range(3):
      leds.show_all(255, 0, 0)
      time.sleep(0.16)
      leds.show_all(0, 0, 0)
      time.sleep(0.16)
  led_count = 0

def random_shuffle(seq):
  l = len(seq)
  for i in range(l):
      j = random.randrange(l)
      seq[i], seq[j] = seq[j], seq[i]
  return seq

def cyclic_color(np):
  color = [0, 0, 0]

  for i in range(NUM_LEDS):
      if i == 0:
          color[0] = random.randint(0, 50)  # 随机颜色
          color[1] = random.randint(0, 50)
          color[2] = random.randint(0, 50)
          np[i] = tuple(color)
      else:
          np[i] = prev
      prev = tuple(np[i])
      np.write()
      time.sleep_ms(50)  # 每个像素之间间隔50毫秒

# 定义颜色渐变函数
def fade_color(color, val):
  return tuple(int(x * val / 255) for x in color)

def breathe_animation(np, start_time, effect_time):
  global thread_stop, effect_type
  colors = [(255, 0, 0), (0, 255, 0), (0, 0, 255)]  # 定义颜色列表，可以根据需要修改

  for i in range(256):  # 呼吸效果的循环
      brightness = int(abs(math.sin(i / 256 * math.pi)) * 255)  # 计算亮度

      for j in range(NUM_LEDS):  # 逐个LED设置颜色
          color = random.choice(colors)  # 随机选择颜色
          np[j] = tuple(map(lambda x: x * brightness // 255, color))  # 设置颜色和亮度

      np.write()  # 更新LED的显示
      time.sleep(0.05)  # 等待一段时间
      current_time = time.ticks_ms()
      if effect_time != "None":
          if current_time - start_time > effect_time * 1000:
              break
      if effect_type != 3 or thread_stop == 1:
          break

# 定义颜色渐变函数
def fade_color(color, val):
  return tuple(int(x * val / 255) for x in color)

# 定义循环呼吸效果函数
def cyclic_breathe(np, start_time, effect_time):
  global thread_stop
  # 随机颜色（R, G, B）值
  r, g, b = tuple(random.randint(0, 255) for _ in range(3))
  for val in range(0, 256, 2):
      # 渐变亮度
      val_normalized = int((val / 255) * 80)
      for i in range(NUM_LEDS):
          np[i] = fade_color((r, g, b), val_normalized)
      np.write()
      time.sleep_ms(10)
      current_time = time.ticks_ms()
      if effect_time != "None":
          if current_time - start_time > effect_time * 1000:
              break
      if effect_type != 1 or thread_stop == 1:
          break
  for val in range(0, 256, 2):
      # 渐变亮度
      val_normalized = int(((255 - val) / 255) * 80)
      for i in range(NUM_LEDS):
          np[i] = fade_color((r, g, b), val_normalized)
      np.write()
      time.sleep_ms(10)
      current_time = time.ticks_ms()
      if effect_time != "None":
          if current_time - start_time > effect_time * 1000:
              break
      if effect_type != 1 or thread_stop == 1:
          break

def waterfall_light(start_time, effect_time):
  global led_index
  led_color = 0

  while True:
      show_single((led_index + 2), 0, 0, 50)
      show_single((led_index + 1), 0, 50, 0)
      show_single(led_index, 50, 0, 0)
      if (led_index > 1):
          led_color = ((led_index - 1))
          while not ((led_color == 0)):
              if (led_color == 1):
                  show_single(led_color, 0, 0, 50)
              if (led_color == 2):
                  show_single(led_color, 0, 0, 50)
                  led_color = ((led_color - 1))
                  show_single(led_color, 0, 50, 0)
              if (led_color > 2):
                  show_single(led_color, 0, 0, 50)
                  led_color = ((led_color - 1))
                  show_single(led_color, 0, 50, 0)
                  led_color = ((led_color - 1))
                  show_single(led_color, 50, 0, 0)
              led_color = ((led_color - 1))
      time.sleep(0.2)
      led_index += 1
      if(led_index > NUM_LEDS - 2):
          led_index = 1
          show_all(0,0,0)

      current_time = time.ticks_ms()
      if effect_time != "None":
          if current_time - start_time > effect_time * 1000:
              led_index = 1
              break
      if effect_type != 4 or thread_stop == 1:
          led_index = 1
          break

def led_task():
  int_led()
  global effect_type, led_color, thread_flag, thread_stop, thread_stop_flag
  thread_flag = 1
  r_led = 0
  g_led = 120
  b_led = 255
  r_led_tepm = 5
  g_led_tepm = 5
  b_led_tepm = -5
  led_sleep_time = 0
  mode_3_stop_falg = 0
  led_mode2_index = [1,2,3]
  random_list = [1,2,3,4,5,6,7,8,9,10]
  led_mode3_index = 0
  start_time = time.ticks_ms()

  while(True):
      time.sleep(0.02)
      if(effect_type == 1):
          cyclic_breathe(_leds, start_time, effect_time)
      elif(effect_type == 4):
          #跑马灯
          # time.sleep(0.2)
          # show_all(0, 0, 0)
          # led_mode2_index[0] = led_mode2_index[0] + 1
          # led_mode2_index[1] = led_mode2_index[1] + 1
          # led_mode2_index[2] = led_mode2_index[2] + 1
          # if(led_mode2_index[0] > 10):
          #     led_mode2_index[0] = led_mode2_index[0] - 10
          # if(led_mode2_index[1] > 10):
          #     led_mode2_index[1] = led_mode2_index[1] - 10
          # if(led_mode2_index[2] > 10):
          #     led_mode2_index[2] = led_mode2_index[2] - 10
          # show_single(led_mode2_index[0],255,0,0)
          # show_single(led_mode2_index[1],0,255,0)
          # show_single(led_mode2_index[2],0,0,255)
          waterfall_light(start_time, effect_time)

      elif(effect_type == 0):
          #随机逐个点亮
          if(mode_3_stop_falg == 1):
              mode_3_stop_falg = 0
              show_all(0, 0, 0)
          time.sleep(0.2)
          led_sleep_time = led_sleep_time + 1
          if(led_mode3_index >= 10):
              random_list = random_shuffle(random_list)
              show_all(0, 0, 0)
              led_mode3_index = 0
          if(led_sleep_time >= 5):
              led_mode3_index = led_mode3_index + 1
              led_sleep_time = 0
          led_color_index = random.randint(1,10)
          led_rgb_color = led_color.get(led_color_index,[])
          show_single(random_list[led_mode3_index - 1], led_rgb_color[0],led_rgb_color[1],led_rgb_color[2])
      elif(effect_type == 3):
          breathe_animation(_leds, start_time, effect_time)
      elif(effect_type == 2):
          # time.sleep(0.02)
          cyclic_color(_leds)


      current_time = time.ticks_ms()
      if effect_time != "None":
          if current_time - start_time > effect_time * 1000:
              thread_stop_flag = 1
              show_all(0, 0, 0)
              break
      if thread_stop == 1:
          show_all(0, 0, 0)
          thread_stop = 0
          break
  thread_flag = 0

def effect(type, time_arg = "None"):
  global effect_type, effect_time, thread_flag, thread_stop, thread_stop_flag, thread_stop
  thread_stop = 1
  time.sleep(0.2)
  effect_type = type
  effect_time = time_arg
  if thread_flag == 0:
      _thread.stack_size(THREAD_SIZE)
      thread_stop_flag = 0
      thread_stop = 0
      _thread.start_new_thread(led_task,())
  while effect_time != "None" and thread_stop_flag == 0:
      time.sleep(0.5)


def effect_stop():
  global thread_stop
  thread_stop = 1
  `,
  servo360: `
import machine
import time
import system_state

version = 0.6
pin_num = 7
servo1 = machine.Pin(pin_num, machine.Pin.OUT)
pwm1 = machine.PWM(servo1)
angle1 = 90

servo_init_flag_1 = False

def set_pin(pin):
  global init_flag, pin_num, servo_init_flag_1
  pin_num = pin
  init_flag = False
  servo_init_flag_1 = False

def get_version():
  return version

def _map_pwm(value, fromlow, fromhigh, tolow, tohigh):
  pwm_value = int((value - fromlow) * (tohigh - tolow) / (fromhigh - fromlow) + tolow)
  if pwm_value < tolow:
      pwm_value = tolow
  if pwm_value > tohigh:
      pwm_value = tohigh
  return pwm_value

# def init():
#     pass

def init(servo_num):
  global pwm1, angle1, servo_init_flag_1, pin_num
  if servo_num == 1 or servo_num == "1":
      servo1 = machine.Pin(pin_num, machine.Pin.OUT)
      pwm1.deinit()
      pwm1 = machine.PWM(servo1)
      pwm1.freq(50)
      pwm1.duty(_map_pwm(angle1,0,180,25,128))
      servo_init_flag_1 = True

def run(angle):
  global servo_init_flag_1
  servo_num = 1
  if(system_state.get_extention_flag(1) == False):
      servo_init_flag_1 = False
      init(servo_num)
      system_state.set_extention_flag(1,True)
  elif(servo_num == 1 and servo_init_flag_1 == False):
      init(1)

  global pwm1, angle1
  if servo_num == 1 or servo_num == "1":
      angle1 = angle
      pwm1.duty(_map_pwm(angle1,0,360,25,128))
  `,
  pins: `
import machine, time

version = 0.3
pwm1 = None
pwm2 = None
pwm1_period = 20000
pwm2_period = 20000
pwm1_value = 0
pwm2_value = 0
pwm1_init_flag = False
pwm2_init_flag = False
d1_pull_mode = "UP"
d2_pull_mode = "UP"
# pwm1_value = value
# servo_pin = machine.Pin(11, machine.Pin.OUT)
# pwm1 = machine.PWM(servo_pin)
# pwm_freq = int(1000000/pwm1_period)
# print(pwm_freq)
# pwm1.freq(50)

def get_version():
  return version

def map(val, min_in, max_in, min_out, max_out):
  if val >= max_in:
      return max_out
  if val <= min_in:
      return min_out
  delta_in = max_in - min_in
  delta_out = max_out - min_out
  return int( ((val - min_in)*delta_out) / delta_in + min_out)

def set_pin_pull_mode(pin_name, pull):
  if (pin_name == "D1") | (pin_name == "d1"):
      pass
  elif (pin_name == "D2") | (pin_name == "d2"):
      pass

def digital_write_pin(pin_name, value):
  if (pin_name == "D1") | (pin_name == "d1"):
      digital_pin = machine.Pin(11, machine.Pin.OUT)
      digital_pin.value(value)
  elif (pin_name == "D2") | (pin_name == "d2"):
      digital_pin = machine.Pin(7, machine.Pin.OUT)
      digital_pin.value(value)

def digital_read_pin(pin_name):
  if (pin_name == "D1") | (pin_name == "d1"):
      digital_pin = machine.Pin(11, machine.Pin.IN)
  elif (pin_name == "D2") | (pin_name == "d2"):
      digital_pin = machine.Pin(7, machine.Pin.IN)

  if digital_pin != None:
      return digital_pin.value()
  else:
      return 0

def analog_set_period(pin_name, period):
  global pwm1, pwm2, pwm1_period, pwm2_period, pwm1_value, pwm2_value, pwm1_init_flag, pwm2_init_flag
  #PWM\u5468\u671f\u9700\u57281 - 1000000us\u4ee5\u5185
  if period > 1000000:
     period = 1000000
  elif period < 1:
      period = 1

  if (pin_name == "D1") | (pin_name == "d1"):
      pwm1_period = period
      if pwm1_init_flag == False:
          servo_pin = machine.Pin(11, machine.Pin.OUT)
          pwm1 = machine.PWM(servo_pin)
          pwm1_init_flag = True
      if pwm1 != None:
          pwm1.freq(int(1000000/pwm1_period))
          # pwm1.duty(map(pwm1_value, 0, 100, 0, 1023))
  if (pin_name == "D2") | (pin_name == "d2"):
      pwm2_period = period
      if pwm2_init_flag == False:
          servo_pin = machine.Pin(7, machine.Pin.OUT)
          pwm2 = machine.PWM(servo_pin)
          pwm2_init_flag = True
      if pwm2 != None:
          pwm2.freq(int(1000000/pwm2_period))
          # pwm2.duty(map(pwm2_value, 0, 100, 0, 1023))

def analog_write_pin(pin_name, value):
  global pwm1, pwm2, pwm1_period, pwm2_period, pwm1_value, pwm2_value, pwm1_init_flag, pwm2_init_flag
  if value > 100:
     value = 100
  elif value < 0:
      value = 0

  if (pin_name == "D1") | (pin_name == "d1"):
      pwm1_value = value
      if pwm1_init_flag == False:
          servo_pin = machine.Pin(11, machine.Pin.OUT)
          pwm1 = machine.PWM(servo_pin)
          pwm1.freq(int(1000000/pwm1_period))
          pwm1_init_flag = True
      if pwm1 != None:
          pwm1.duty(map(pwm1_value, 0, 100, 0, 1023))

  elif (pin_name == "D2") | (pin_name == "d2"):
      pwm2_value = value
      if pwm2_init_flag == False:
          servo_pin = machine.Pin(7, machine.Pin.OUT)
          pwm2 = machine.PWM(servo_pin)
          pwm2.freq(int(1000000/pwm1_period))
          pwm2_init_flag = True
      if pwm2 != None:
          pwm2.duty(map(pwm1_value, 0, 100, 0, 1023))

def analog_read_pin(pin_name):
  if (pin_name == "D1") | (pin_name == "d1"):
      analog_pin = machine.Pin(11, machine.Pin.IN, machine.Pin.PULL_UP)
  elif (pin_name == "D2") | (pin_name == "d2"):
      analog_pin = machine.Pin(7, machine.Pin.IN, machine.Pin.PULL_UP)

  if analog_pin != None:
      adc1 = machine.ADC(analog_pin)
      adc1.atten(machine.ADC.ATTN_11DB)
      val = adc1.read()
      return map(int(val), 0, 4095, 0, 100)
  else:
      return 0

def pulse_in(pin_name, value, timeout_us = 2000000):
  if (pin_name == "D1") | (pin_name == "d1"):
      pulse_pin = machine.Pin(11, machine.Pin.IN)
  elif (pin_name == "D2") | (pin_name == "d2"):
      pulse_pin = machine.Pin(7, machine.Pin.IN)
  return machine.time_pulse_us(pulse_pin, value, timeout_us)
  `,
  ports: `
try:
  import extention.led_strip as led_strip
except:
  pass
# import launcher
try:
  import extention.servo360 as servo360
except:
  pass
try:
  import extention.temperature_humidity_sensor as temperature_humidity_sensor
except:
  pass

version = 0.2

def get_version():
  return version

def set_pin_function(pin_name, function):
  if pin_name == 1:
      pin = 11
  elif pin_name == 2:
      pin = 7
  if function == "led_strip":
      led_strip.set_pin(pin)
  elif function == "servo360":
      servo360.set_pin(pin)
  elif function == "temperature_humidity_sensor":
      temperature_humidity_sensor.set_pin(pin)
  `,
};
